import { render } from "./ImageElement.vue?vue&type=template&id=f8f4cc06&scoped=true"
import script from "./ImageElement.vue?vue&type=script&lang=js"
export * from "./ImageElement.vue?vue&type=script&lang=js"

import "./ImageElement.vue?vue&type=style&index=0&id=f8f4cc06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8f4cc06"]])

export default __exports__